// Section reveal with intersection observer
const revealSection = (entries, observer) => {
  if (entries?.length === 0) return;
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add("section-in-view", "reveal");
    } else {
      entry.target.classList.remove("section-in-view");
    }
  });
};

const sectionObserver = new IntersectionObserver(revealSection, {
  root: null,
  threshold: 0.05,
});

document.addEventListener("DOMContentLoaded", () => {
  if (Shopify.designMode) {
    document.body.classList.add("designMode");
    return false;
  }
  document.querySelectorAll(".shopify-section").forEach((section) => {
    if (section.querySelector("[data-disable-reveal]") || section.classList.contains("disabled-reveal")) {
      section.classList.add("section-in-view", "reveal");
    }
    sectionObserver.observe(section);
  });

  // Remove cents from price
  function updatePrice() {
    var prices = document.querySelectorAll(`sale-price, compare-at-price`);
    if (!prices) return;
    for (var each of prices) {
      each.innerHTML = each.innerHTML.replace(".00", "");
    }
  }
  if (document.querySelector("body").classList.contains("template-product")) {
    setTimeout(updatePrice, 50);
  }

  // Sticky Add To cart scroll to top on mobile when pdp has more than 1 variant
  if (document.querySelector(".product-sticky-bar") && window.innerWidth < 768) {
    document
      .querySelector(
        ".product-sticky-bar button.typography-desktop-14--button typography-mobile-13--button button--lwp"
      )
      .addEventListener("click", function(e) {
        if (document.querySelector("[data-option-selector]")) {
          e.preventDefault();
          e.stopPropagation();
          const scrollPos = document.querySelector(".product-info").getBoundingClientRect().top + window.scrollY;
          window.scrollTo({ top: scrollPos, behavior: "smooth" });
        }
      });
  }

  const newsletterForms = document.querySelectorAll(".newsletter__item-form");
  if (newsletterForms.length > 0) {
    newsletterForms.forEach((newsletterForm) => {
      const observer = new MutationObserver((mutationsList, observer) => {
        for (let mutation of mutationsList) {
          if (mutation.type === "childList") {
            if (mutation.target.querySelector("[id*='rich-text']")) {
              let newsletterWrapper =  newsletterForm.closest(".newsletter.main-wrapper");
              if (newsletterWrapper) {
                observer.disconnect();
                newsletterWrapper.querySelector(".newsletter__message--default").classList.remove("active");
                newsletterWrapper.querySelector(".newsletter__message--success").classList.add("active");
                newsletterForm.style.display = "none";
              }
            }
          }
        }
      });

      observer.observe(newsletterForm, { childList: true, subtree: true });
    });
  }

});
